import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'Service/api/api';

const getWeeklyWeather = createAsyncThunk(
  'weather/getWeeklyWeather',
  ({ location }: { location: string }) => {
    try {
      return api.weather.getWeeklyWeather(location);
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export { getWeeklyWeather };
